<script setup>
const props = defineProps({
  blocks: Array,
});
defineEmits(['startScan']);
</script>

<template>
  <template v-for="block in blocks">
    <BlocksTypesContent
      v-if="block.type === 'blockContent'"
      :content="block.content"
    />
    <BlocksTypesTextImage
      v-else-if="block.type === 'blockTextImage'"
      :switch-blocks="block.switchBlocks"
      :text="block.text"
      :image="block.image"
    />
    <BlocksTypesFullImage
      v-else-if="block.type === 'blockFullImage'"
      :image="block.image"
    />
    <BlocksTypesCampaign
      v-else-if="block.type === 'blockCampaign'"
      :title="block.title"
      :text="block.text"
      :link="block.link"
      :image="block.image"
    />
    <BlocksTypesTextVideo
      v-else-if="block.type === 'blockTextVideo'"
      :text="block.text"
      :video="block.video"
    />
    <BlocksTypesQuote
      v-else-if="block.type === 'blockQuote'"
      :text="block.text"
      :subtitle="block.subtitle"
    />
    <BlocksTypes2ColText
      v-else-if="block.type === 'block2ColText'"
      :text="block.text"
      :text2="block.text2"
    />
    <BlocksTypes2ColWcagContact
      v-else-if="block.type === 'block2ColWCAGContact'"
      :text="block.text"
      :textContact="block.textContact"
      :image="block.image"
      :link="block.link"
      @startScan="$emit('startScan')"
    />
    <BlocksTypesBigText
      v-else-if="block.type === 'blockBigText'"
      :text="block.text"
    />
  </template>
</template>

<style></style>
